import { gql } from "@apollo/client";

export const query_GetManyDocumentsWithFields = gql`
  query GetManyDocuments($input: GetManyDocumentsRequestInput) {
    GetManyDocuments(input: $input) {
      connection {
        edges {
          cursor
          node {
            blueprintBranch
            archivedAt
            blueprintId
            createdAt
            createdByUserId
            documentId
            environmentId
            previewImageUrl
            projectId
            publishedAt
            statusId
            title
            updatedAt
            lastUpdatedByUserId
            fields {
              data
              blueprintFieldId
              documentFieldLocaleId
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
      }
    }
  }
`;
